import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Media from 'react-media';
import Sidebar from 'react-sidebar';

import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/fontawesome-free-solid';

import 'bootstrap/dist/css/bootstrap.css';
import './App.css';
import SongContainer from './containers/SongContainer';
import ToolbarContainer from './containers/ToolbarContainer';

import MetaFormContainer from './containers/MetaContainer';
import SectionFormContainer from './containers/SectionFormContainer';
// import SelectedItemsContainer from './containers/SelectedItemsContainer';
import LineCardContainer from './containers/LineCardContainer';
import SongUploadContainer from './containers/SongUploadContainer';
import SongListContainer from './containers/SongListContainer';

export default class App extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      sidebarOpen: false,
    };
    this.toggleSidebar = this.toggleSidebar.bind(this);
  }

  toggleSidebar(open) {
    this.setState({
      ...this.state,
      sidebarOpen: open === undefined ? !this.state.sidebarOpen : open,
    });
  }

  render() {
    const rightRoutes = [
      <Route key={0} path="/song/:sectionIndex/:lineIndex" component={LineCardContainer} />,
      <Route key={1} path="/song/:sectionIndex" component={SectionFormContainer} />,
      <Route key={2} path="/meta" component={MetaFormContainer} />,
      <Route key={3} path="/section/:id" component={SectionFormContainer} />,
      <Route key={4} path="/line/:id" component={LineCardContainer} />,
    ];
    const leftRoutes = [
      <Route key={5} path="/songs" component={SongListContainer} />,
      <Route key={5} path="/upload-song" component={SongUploadContainer} />,
      <Route key={6} component={SongContainer} />,
    ];
    const xsRoutes = [...rightRoutes, ...leftRoutes];

    const xsContent = (
      <div>
        <nav className="navbar fixed-top navbar-dark" style={{ background: '#ef6c00' }}>
          <a className="navbar-brand" href="#home" onClick={this.toggleSidebar}>
            <FontAwesomeIcon icon={faBars} className="mr-3" />
            songwrite.app
          </a>
        </nav>
        <div className="p-3" style={{ marginTop: '56px' }}>
          <Switch>{xsRoutes}</Switch>
        </div>
      </div>
    );

    const WrappedToolbarContainer = props => (
      <ToolbarContainer onSidebarSetOpen={this.toggleSidebar} {...props} />
    );
    return (
      <Router>
        <Media query="(max-width: 767px)">
          {matches =>
            (matches ? (
              <Sidebar
                sidebar={
                  <div style={{ height: '100%', background: '#fff', width: '280px' }}>
                    <Route component={WrappedToolbarContainer} />
                  </div>
                }
                open={this.state.sidebarOpen}
                onSetOpen={this.toggleSidebar}
                styles={{
                  sidebar: { zIndex: 2002 },
                  overlay: { zIndex: 2001 },
                  dragHandle: { zIndex: 2001 },
                }}
              >
                <div className="App">{xsContent}</div>
              </Sidebar>
            ) : (
              <div>
                <div className="sidebar-fixed">
                  <Route component={ToolbarContainer} />
                </div>
                <div className="p-3" style={{ marginLeft: '170px' }}>
                  <div className="row">
                    <div className="col-md-7 col-lg-7 col-xl-6 offset-xl-1">
                      <Switch>{leftRoutes}</Switch>
                    </div>
                    <div className="col-md-5 col-xl-4 offset-xl-1">
                      <div id="properties" className="bg-light">
                        {/* <Route exact path="/" component={SelectedItemsContainer} /> */}
                        <Switch>{rightRoutes} </Switch>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))
          }
        </Media>
      </Router>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.js